import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteData } from "../types";
import { deleteQuote } from "../apis/deleteQuote";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useDeleteQuote = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, number>({
        mutationFn: deleteQuote,
        onSuccess: (_res, id_quote) => {
            // Drop the quote from the cached list right away: the list must update
            // as soon as the delete succeeds, without waiting for the refetch.
            queryClient.setQueryData<QuoteData[]>(["quotes"], (prev) =>
                prev ? prev.filter((quote) => quote.id_quote !== id_quote) : prev
            );
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
            queryClient.invalidateQueries({ queryKey: withPrefix(["quotes-stats"]) });
        },
    });
};
